import Common from "../../../Shared/Common";

const CompsAPI = {

    getPucko: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Clubs/getPucko", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },
    getSpecies: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Clubs/getSpecies", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },
    getSpecies: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Clubs/getSpecies", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },
};
export default CompsAPI;

